module.exports = __webpack_public_path__ + "static/media/HP_card_1600golf.516351bd.jpg";